// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__JZ9Y-","buttonNav":"style_buttonNav__dRfWO","Desklogo":"style_Desklogo__+qUkU","Moblogo":"style_Moblogo__QUMMq"};